import { useEffect, useState } from 'react'

/**
 * Forces a re-render every `intervalMs` (default 30s) so time-derived values computed at
 * render time — e.g. `isRegistrationOpen(event)`, which compares `Date.now()` against a fixed
 * deadline — stay accurate on a page left open across that deadline, instead of only updating
 * on the next unrelated re-render or full page reload.
 */
export function useLiveTick(intervalMs = 30_000): number {
  const [tick, setTick] = useState(0)
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return tick
}
